__turbopack_context__.v({
  "fieldset": "FieldSet-module-scss-module__iyzxBG__fieldset",
});
